import { genderRouters } from './gender'
import Permissions from '@/permissions'
import { villageRouters } from '@/routers/settings/village'
import { communeRouters } from '@/routers/settings/commune'
import { districtRouters } from '@/routers/settings/district'
import { provinceRouters } from '@/routers/settings/province'
import { logsViewerRouters } from '@/routers/settings/logs'
import { projectTypeRouters } from '@/routers/settings/projectType'
import { positionRouters } from '@/routers/settings/position'

export const settingRouters = {
  path: 'settings',
  name: 'settings',
  component: () => import('@/views/settings/Index'),
  redirect: 'gender',
  meta: {
    permissions: [Permissions.backend.setting.manage]
  },
  children: [
    genderRouters,
    villageRouters,
    communeRouters,
    districtRouters,
    provinceRouters,
    projectTypeRouters,
    logsViewerRouters,
    positionRouters
  ]
}
